(function () {
  'use strict';

  var ROOT_SELECTOR = '.marquee-offer-bar';

  function getSpeedLevel(section) {
    var useMobile = section.dataset.marqueeUseMobileSpeed === 'true';
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    if (useMobile && isMobile) {
      return parseInt(section.dataset.marqueeSpeedMobile || section.dataset.marqueeSpeed || '5', 10);
    }

    return parseInt(section.dataset.marqueeSpeed || '5', 10);
  }

  function speedToDuration(speedLevel) {
    var minSpeed = 1;
    var maxSpeed = 10;
    var minDuration = 8;
    var maxDuration = 70;
    var speed = Math.min(maxSpeed, Math.max(minSpeed, speedLevel));

    return maxDuration - ((speed - minSpeed) / (maxSpeed - minSpeed)) * (maxDuration - minDuration);
  }

  function applyScrollDuration(section) {
    var duration = speedToDuration(getSpeedLevel(section));
    section.style.setProperty('--marquee-duration', duration + 's');
  }

  function parseDurationSeconds(section) {
    var inline = section.getAttribute('style') || '';
    var match = inline.match(/--marquee-duration:\s*([\d.]+)s/i);
    if (match) return parseFloat(match[1]);

    var computed = getComputedStyle(section).getPropertyValue('--marquee-duration').trim();
    match = computed.match(/^([\d.]+)s$/);
    return match ? parseFloat(match[1]) : 28;
  }

  function getTrackTranslateX(track) {
    var transform = getComputedStyle(track).transform;
    if (!transform || transform === 'none') return 0;

    if (window.DOMMatrix) {
      return new DOMMatrix(transform).m41;
    }

    var matrixMatch = transform.match(/matrix\(([^)]+)\)/);
    if (!matrixMatch) return 0;

    var values = matrixMatch[1].split(',');
    return parseFloat(values[4]) || 0;
  }

  function syncClones(track, source, cloneCount) {
    var clones = track.querySelectorAll('[data-marquee-clone]');

    if (clones.length > cloneCount) {
      for (var i = clones.length - 1; i >= cloneCount; i -= 1) {
        clones[i].remove();
      }
    }

    var currentCount = track.querySelectorAll('[data-marquee-clone]').length;

    for (var j = currentCount; j < cloneCount; j += 1) {
      var clone = source.cloneNode(true);
      clone.removeAttribute('data-marquee-source');
      clone.setAttribute('data-marquee-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    if (!track.contains(source)) {
      track.insertBefore(source, track.firstChild);
    }
  }

  function shouldSkipRebuild(section, track, loopWidth, cloneCount) {
    if (!section.classList.contains('marquee-offer-bar--ready')) return false;

    var prevLoopWidth = parseFloat(section.style.getPropertyValue('--marquee-loop-width')) || 0;
    var existingClones = track.querySelectorAll('[data-marquee-clone]').length;

    return (
      existingClones === cloneCount &&
      prevLoopWidth > 0 &&
      Math.abs(prevLoopWidth - loopWidth) < 2
    );
  }

  function finishBuild(section, track) {
    requestAnimationFrame(function () {
      track.style.transform = '';
      section.classList.remove('marquee-offer-bar--rebuilding');
      section.classList.add('marquee-offer-bar--ready');
      section.classList.add('marquee-offer-bar--start-delay');

      window.setTimeout(function () {
        section.classList.remove('marquee-offer-bar--start-delay');
      }, 300);
    });
  }

  function buildLoop(section) {
    var viewport = section.querySelector('.marquee-offer-bar__viewport');
    var track = section.querySelector('.marquee-offer-bar__track');
    var source = section.querySelector('[data-marquee-source]');

    if (!viewport || !track || !source) return;

    var loopWidth = source.getBoundingClientRect().width;
    if (!loopWidth) return;

    var viewportWidth = viewport.offsetWidth;
    var cloneCount = Math.max(1, Math.ceil((viewportWidth * 2) / loopWidth));

    if (shouldSkipRebuild(section, track, loopWidth, cloneCount)) {
      applyScrollDuration(section);
      return;
    }

    var wasReady = section.classList.contains('marquee-offer-bar--ready');
    var previousLoopWidth =
      parseFloat(section.style.getPropertyValue('--marquee-loop-width')) || loopWidth;
    var preservedOffset = wasReady ? getTrackTranslateX(track) % previousLoopWidth : 0;

    section.classList.add('marquee-offer-bar--rebuilding');
    section.classList.remove('marquee-offer-bar--ready');
    track.style.transform = 'translate3d(' + preservedOffset + 'px, 0, 0)';

    syncClones(track, source, cloneCount);

    loopWidth = source.getBoundingClientRect().width;
    if (!loopWidth) {
      section.classList.remove('marquee-offer-bar--rebuilding');
      return;
    }

    section.style.setProperty('--marquee-loop-width', loopWidth + 'px');
    applyScrollDuration(section);

    var duration = parseDurationSeconds(section);
    var pxPerSecond = loopWidth / duration;
    section.style.setProperty('--marquee-px-per-second', pxPerSecond + 'px');

    finishBuild(section, track);
  }

  function setupResizeObserver(section) {
    if (typeof ResizeObserver === 'undefined') return;

    var viewport = section.querySelector('.marquee-offer-bar__viewport');
    var source = section.querySelector('[data-marquee-source]');
    if (!viewport || !source) return;

    var frame = null;
    var observer = new ResizeObserver(function () {
      if (Date.now() < (parseInt(section.dataset.marqueeStableUntil || '0', 10) || 0)) return;

      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        buildLoop(section);
      });
    });

    observer.observe(viewport);
    observer.observe(source);
    section._marqueeResizeObserver = observer;
  }

  function initMarquee(section) {
    if (!section || !(section instanceof Element)) return;

    if (section._marqueeResizeObserver) {
      section._marqueeResizeObserver.disconnect();
      section._marqueeResizeObserver = null;
    }

    if (section._marqueeMediaQuery && section._marqueeMediaHandler) {
      section._marqueeMediaQuery.removeEventListener('change', section._marqueeMediaHandler);
      section._marqueeMediaQuery = null;
      section._marqueeMediaHandler = null;
    }

    section.classList.remove('marquee-offer-bar--ready');
    buildLoop(section);
    section.dataset.marqueeInitialized = 'true';
    section.dataset.marqueeStableUntil = String(Date.now() + 800);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setupResizeObserver(section);
      });
    });

    if (section.dataset.marqueeUseMobileSpeed === 'true' && window.matchMedia) {
      var mediaQuery = window.matchMedia('(max-width: 767px)');
      var mediaHandler = function () {
        buildLoop(section);
      };

      mediaQuery.addEventListener('change', mediaHandler);
      section._marqueeMediaQuery = mediaQuery;
      section._marqueeMediaHandler = mediaHandler;
    }
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initMarquee);

    if (root && root.matches && root.matches(ROOT_SELECTOR)) {
      initMarquee(root);
    }
  }

  function scheduleInit(root) {
    var run = function () {
      initAll(root || document);
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(run);
      return;
    }

    run();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleInit(document);
    });
  } else {
    scheduleInit(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleInit(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;

    section.querySelectorAll(ROOT_SELECTOR).forEach(function (node) {
      if (node._marqueeResizeObserver) {
        node._marqueeResizeObserver.disconnect();
        node._marqueeResizeObserver = null;
      }

      if (node._marqueeMediaQuery && node._marqueeMediaHandler) {
        node._marqueeMediaQuery.removeEventListener('change', node._marqueeMediaHandler);
        node._marqueeMediaQuery = null;
        node._marqueeMediaHandler = null;
      }
    });
  });
})();
